import { Grid, GridProps as ChakraUIGridProps } from "@chakra-ui/react";

export type GridProps = Pick<
  ChakraUIGridProps,
  "templateColumns" | "gap" | "padding" | "width" | "children"
>;

export function GridLayout({
  children,
  templateColumns = { base: "repeat(4, 1fr)", lg: "repeat(12, 1fr)" },
  gap = { base: "1rem", lg: "1.5rem" },
  padding = { base: "0rem 1rem", lg: "0rem 1.5rem" },
  width = "100%"
}: GridProps): JSX.Element {
  return (
    <Grid
      templateColumns={templateColumns}
      gap={gap}
      padding={padding}
      width={width}
    >
      {children}
    </Grid>
  );
}
